import styles from './index.less';
import $ from 'jquery';
import Modal from '../modal';

const defaultPrams = {
  html: '',
};
export default class RichTextModal extends Modal {
  constructor(props) {
    super(props);
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this._initContent();
  }
  _initContent() {
    const params = this.params;
    let newHtml = params.html.replace('video-wrap"','video-wrap" style="text-align:center;"')
    this.$richtext = $(
      `<div class="${styles['richtext-wrapper']}">
        <div class="${styles['richtext-c']}">
          ${newHtml}
        </div>
      </div>`,
    );
    this.$dom.append(this.$richtext);
  }
}
